module.exports = __webpack_public_path__ + "static/img/14000294.f903300a.png";